import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/crm/flow/node/person/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

export function saveOrUpdate(data) {
  return request({
    url: "/crm/flow/node/person/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/crm/flow/node/person/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/crm/flow/node/person/deleteById",
    method: "post",
    data: { id: id },
  });
}

// 客户审批人查询
export function getByGeneralManager(nodePerson,roleId, pagination) {
    return request({
      url: "/crm/flow/node/person/getByGeneralManager",
      method: "post",
      data: { nodePerson,roleId,pagination },
    });
  }


